import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FeatureFlagService, FLAGS } from '../services/feature-flag.service';

@Injectable({
	providedIn: 'root',
})
export class DevPlaygroundGuard implements CanActivate {
	constructor(private featureFlagService: FeatureFlagService) {}
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return of(this.featureFlagService.isFeatureEnabledV2(FLAGS.DevPlayground));
	}
}
